<script setup lang="ts">
import {Link} from "@inertiajs/vue3";
import ButtonComponent from "@components/button.vue";
import {computed, ref} from "vue";
import {CategoriesInterface} from "@interfaces/CategoriesInterface.js";
import { trans } from "laravel-vue-i18n";


let props = defineProps<{
    category: CategoriesInterface
}>();

const categories = ref([
    {
        slug: 'voor-gamers',
        titleKey: 'pages.category.header.for_gamers.title',
    },
    {
        slug: 'voor-thuis',
        titleKey: 'pages.category.header.for_home.title',
        subtitleKey: 'pages.category.header.for_home.subtitle',
        backgroundImage: '/images/home-category.png',
    },
    {
        slug: 'voor-op-kantoor',
        titleKey: 'pages.category.header.for_office.title',
        subtitleKey: 'pages.category.header.for_office.subtitle',
        backgroundImage: '/images/office-category.webp',
    }
]);

let currentCategory = computed(() =>
    categories.value.find((c) => c.slug === props.category.slug)
);

let title = computed(() => currentCategory.value && trans(currentCategory.value.titleKey));
let subtitle = computed(() => currentCategory.value?.subtitleKey && trans(currentCategory.value.subtitleKey));
let backgroundImage = computed(() => currentCategory.value?.backgroundImage);

</script>
<template>
    <section id="category-section-header">
        <div class="background-image">
            <img
                v-if="backgroundImage"
                class="image"
                :alt="title"
                :src="backgroundImage">

            <img
                alt="Accent"
                class="background-image-lines"
                src="/images/lines.png">
            <img
                alt="Accent"
                class="background-image-accent"
                src="/images/light-accent.svg">

        </div>

        <div class="content">
            <h2>{{ trans('pages.category.slogan') }}</h2>
            <h1>{{ title }}</h1>
            <p class="subtitle">
                {{ subtitle }}
            </p>
            <Link
                class="button"
                :href="route('preconfig.all')"
            >
                <button-component
                    class="button"
                    color="slate"
                >
                    {{ trans('pages.category.discover_button') }}
                </button-component>
            </Link>
            <img
                alt="De Level One Standing Desk"
                class="desk"
                src="/images/gaming-desk-category.png">
        </div>
    </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/category/sections/header";
</style>
